import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';
import Users03Icon from 'src/icons/untitled-ui/duocolor/users-03';
import Car01Icon from 'src/icons/untitled-ui/free/car-01';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import GraduationHat01Icon from 'src/icons/untitled-ui/duocolor/graduation-hat-01';
import DataFlow04Icon from 'src/icons/untitled-ui/free/dataflow-04';

export const adminSections = (t, tokens, paths, SvgIcon) => {
  return [
    {
      items: [
        {
          title: t(tokens.nav.overview),
          path: paths.dashboard.index,
          icon: (
            <SvgIcon fontSize="small">
              <HomeSmileIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.workSchedule),
          path: paths.schedules.work.index,
          icon: (
            <SvgIcon fontSize="small">
              <EventOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.repairRequest),
          path: paths.repairs.requests,
          icon: (
            <SvgIcon fontSize="small">
              <BuildCircleOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.payroll),
          path: paths.payrolls.index,
          icon: (
            <SvgIcon fontSize="small">
              <AccountBalanceWalletOutlinedIcon />
            </SvgIcon>
          ),
        },
        // {
        //   title: t(tokens.nav.staff),
        //   path: paths.staff.index,
        //   icon: (
        //     <SvgIcon fontSize="small">
        //       <AssignmentIndOutlinedIcon />
        //     </SvgIcon>
        //   ),
        // },
        {
          title: t(tokens.nav.carManagement),
          path: paths.cars.index,
          icon: (
            <SvgIcon fontSize="small">
              <Car01Icon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.groups),
          path: paths.groups.index,
          icon: (
            <SvgIcon fontSize="small">
              <AccountTreeOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.partner),
          path: paths.partners.index,
          icon: (
            <SvgIcon fontSize="small">
              <HandshakeOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.tracking),
          path: paths.tracking.index,
          icon: (
            <SvgIcon fontSize="small">
              <DataFlow04Icon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.course),
          path: paths.courses.index,
          icon: (
            <SvgIcon fontSize="small">
              <GraduationHat01Icon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.account),
          path: paths.accounts.index,
          icon: (
            <SvgIcon fontSize="small">
              <Users03Icon />
            </SvgIcon>
          ),
        },
      ],
    },
  ];
};
